// apps/frontend-vario-gambio/src/lib/category-logic.ts
// Reine, IO-freie Kategorie-Logik fuer den Gambio-Kategorien-Editor (Frontend).
// VERBATIM-Kopie der getesteten Referenz aus apps/worker/src/lib/gambio-category-admin-logic.ts —
// das Frontend importiert NICHT aus apps/worker/src, daher diese lokale, verhaltensgleiche Kopie.
// Bleibt synchron zur Worker-Referenz (kleine, pure Funktionen).

export interface FlatCategory {
  gambioId: number;
  parentId: number;
  name: string;
  isActive: boolean;
  sortOrder: number;
}
export interface CategoryTreeNode extends FlatCategory {
  children: CategoryTreeNode[];
}
export type MultiLang = Record<string, string>;

export function buildCategoryTree(flat: ReadonlyArray<FlatCategory>): CategoryTreeNode[] {
  const byId = new Map<number, CategoryTreeNode>();
  for (const c of flat) byId.set(c.gambioId, { ...c, children: [] });
  const roots: CategoryTreeNode[] = [];
  for (const node of byId.values()) {
    const parent = node.parentId && node.parentId !== 0 ? byId.get(node.parentId) : undefined;
    if (parent && parent.gambioId !== node.gambioId) parent.children.push(node);
    else roots.push(node);
  }
  const sortRec = (nodes: CategoryTreeNode[]): void => {
    nodes.sort((a, b) => a.sortOrder - b.sortOrder || a.gambioId - b.gambioId);
    for (const n of nodes) sortRec(n.children);
  };
  sortRec(roots);
  return roots;
}

export function missingLanguages(value: MultiLang, activeLangs: ReadonlyArray<string>): string[] {
  return activeLangs.filter((l) => !((value?.[l] ?? '').trim().length > 0));
}

export function descendantIds(flat: ReadonlyArray<FlatCategory>, rootId: number): number[] {
  const childrenOf = new Map<number, number[]>();
  for (const c of flat) {
    const arr = childrenOf.get(c.parentId) ?? [];
    arr.push(c.gambioId);
    childrenOf.set(c.parentId, arr);
  }
  const out: number[] = [];
  const stack = [...(childrenOf.get(rootId) ?? [])];
  const seen = new Set<number>();
  while (stack.length) {
    const id = stack.pop()!;
    if (seen.has(id)) continue;
    seen.add(id);
    out.push(id);
    for (const c of childrenOf.get(id) ?? []) stack.push(c);
  }
  return out;
}
